export const IDENTITY_VERIFICATION_DIALOG_OPEN = 'Rollo/IDENTITY_VERIFICATION_DIALOG_OPEN';
export const IDENTITY_VERIFICATION_DIALOG_CLOSE = 'Rollo/IDENTITY_VERIFICATION_DIALOG_CLOSE';
export const IDENTITY_VERIFICATION_IN_PROGRESS = 'Rollo/IDENTITY_VERIFICATION_IN_PROGRESS';

export type IdentityVerificationVariant = 'required' | 'profile';

type IdentityVerificationCallbacks = {
  onNotNow?: () => void;
  onClose?: () => void;
  forceOpen?: boolean;
  variant?: IdentityVerificationVariant;
};

export const openIdentityVerificationDialog = (callbacks?: IdentityVerificationCallbacks) => ({
  type: IDENTITY_VERIFICATION_DIALOG_OPEN,
  payload: callbacks || {},
});

export const closeIdentityVerificationDialog = (dismissedKey?: string) => ({
  type: IDENTITY_VERIFICATION_DIALOG_CLOSE,
  payload: { dismissedKey },
});

export const setIdentityVerificationInProgress = (inProgress: boolean) => ({
  type: IDENTITY_VERIFICATION_IN_PROGRESS,
  payload: { inProgress },
});
